import Vue from 'vue';
import Router from 'vue-router';

import Home from './views/Home';
import Result from "./views/Result";
import Description from "./views/Description";
import FAQ from "./views/FAQ";
import Download from "./views/Download";
import Link from "./views/Link";
import Contact from "./views/Contact";

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    },
    {
      path: '/description',
      name: 'description',
      component: Description
    },
    {
      path: '/faq',
      name: 'faq',
      component: FAQ
    },
    {
      path: '/download',
      name: 'download',
      component: Download
    },
    {
      path: '/link',
      name: 'link',
      component: Link
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
  ]
});
